import axios from 'axios';
import qs from 'qs';

export default {
  sendRequest: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    commit('requester/SET_RESPONSE', null, { root: true });
    commit('requester/SET_REQUEST_STATE', 1, { root: true });
    commit('requester/SET_REQUEST_START_TIME', new Date().getTime(), { root: true });
    axios({
      url: '/engine/requester',
      method: "POST",
      data: qs.stringify(payload),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    })
      .then((response) => {
        commit('requester/SET_REQUEST_STATE', 2, { root: true });
        commit('requester/SET_REQUEST_END_TIME', new Date().getTime(), { root: true });
        commit('requester/SET_RESPONSE', response.data, { root: true });
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(response.data);
      })
      .catch(err => {
        commit('requester/SET_RESPONSE', err.response, { root: true });
        commit('requester/SET_REQUEST_STATE', 3, { root: true });
        commit('requester/SET_REQUEST_END_TIME', new Date().getTime(), { root: true });
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  saveRequest: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const { requestId, ...rest } = payload;
    const url = requestId ? `/engine/requester/requests/${requestId}` : '/engine/requester/requests';
    axios({
      url: url,
      method: "POST",
      data: JSON.stringify(rest),
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('requester/ADD_REQUEST', response.data, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  }
};